<style lang="scss">

</style>

<template>
  <section class="ui-stats-item">
    <div class="col-12">
      <h4 class="font-weight-bold text-center title-divider top-divider">Shows cancellation reasons for the last {{filters.days}} days</h4>

      <section class="d-flex full-width my-2">
        <div class="ui-spacer"></div>
        <select style="max-width: 300px" @change="updateActiveChart"
                class="form-control select-arrow" :value="activeChart">
          <option value="prison">cancellation reasons ({{$options.filters.term('prison', true) }})</option>
          <option value="visitor">cancellation reasons (Caller)</option>
        </select>
      </section>

      <div style="min-height: 350px">

        <section class="mt-1"  v-if="!loadingStats && !loadingChart">
          <div v-if="activeChart === 'prison'">
            <pie-chart-simple v-if="stats.prison_reasons.length > 0"
                              max-width="600px" chart-id="chartPrison" :series="chartPrisonSimple"></pie-chart-simple>
            <p v-else>No cancellation reasons in past {{filters.days}} days</p>
          </div>
          <div v-if="activeChart === 'visitor'">
            <pie-chart-simple v-if="stats.visitor_reasons.length > 0"
                              max-width="600px" chart-id="chartVisitor" :series="chartVisitorSimple"></pie-chart-simple>
            <p v-else>No cancellation reasons in past {{filters.days}} days</p>
          </div>
        </section>

        <section v-else class="d-flex justify-content-center pb-4 pt-5 flex-wrap">
          <p class="full-width d-flex justify-content-center">Getting Stats...</p>
          <b-spinner variant="primary"></b-spinner>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex';
  import VisitsService from '../../../services/VisitService';
  import HelperService from '../../../services/HelperService';
  import PieChartSimple from '../../../components/charts/PieChartSimple.vue';

  export default {
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    components: {
      PieChartSimple,
    },
    watch: {
      filters: {
        handler() {
          this.getCancellationReasonStats();
        },
        deep: true,
      },
      activeChart() {
        this.loadingChart = true;

        setTimeout(() => {
          this.loadingChart = false;
        }, 500);
      }
    },
    computed: mapState({
      activeChart: state => state.stats.activeCancelChart
    }),
    data() {
      return {
        helperService: new HelperService(),
        loadingStats: true,
        // activeChart: 'prison',
        stats: [],
        chartPrisonSimple: null,
        chartVisitorSimple: null,
        loadingChart: false,
      };
    },
    mounted() {
      this.getCancellationReasonStats();
    },
    methods: {
      updateActiveChart(e) {
        this.$store.commit('stats/SET_ACTIVE_CANCEL_CHART', e.target.value);
      },
      getCancellationReasonStats() {
        this.loadingStats = true;

        if (this.filters.prisonId || this.filters.prisonGroupId) {
          return VisitsService.getVisitCancellationReasonStats(this.filters).then((res) => {
            this.stats = res.data;
            this.chartPrisonSimple = this.createChartJsChart(this.stats.prison_reasons);
            this.chartVisitorSimple = this.createChartJsChart(this.stats.visitor_reasons);
          }).catch((err) => {
            console.log('could not get cancellation stats', err);
            this.$toasted.error('Network timed out please try a shorter time range');
          }).finally(() => {
            setTimeout(() => {
              this.loadingStats = false;
            }, 1000);
          });
        }

        return null;
      },
      createChartJsChart(reasons) {
        let chart = {
          data: [],
          labels: [],
        };

        reasons.forEach((reason) => {
          chart.data.push(reason.total);
          chart.labels.push(reason.reason);
        });

        return chart;
      },
    },
  };
</script>
